import { Typography } from '@mui/material';
import DefaultLayout from 'layouts/default';
import './index.css';
const NotFound = () => {
  return (
    <DefaultLayout>
      <div className="NotFound">
        <div className="notfound-text">
          <Typography variant="h4" className="line-text">
            <Typography variant="h3">404</Typography>
            <br /> We're good at robots, but not at delivering incorrect urls 🤖
          </Typography>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default NotFound;
